import { PRODUCT_READING } from 'root/lib/constants';
import { getTimestamp } from 'root/lib/DatetimeManager';

import gameIds from '../data/GameIds';
import { persistStateTypes } from '../../reducers/persistStateReducer';
import questState from './state/questState';
import { SEASON } from '../data/constants';
import validateReducerData from './actionHandlers/serverResponseHandler';
import STEP_TYPE from '../data/StepTypes';
import { isMatchingGame } from '../../../lib/utilityFunctions';
import MapQuestsLectura from '../data/MapQuestsLectura.json';

let steps;
let selectedStep;
let levelsMastered;
let index;

let product;
let newQuestStepsCache;
let cacheIndex;

const questWorkflowReducer = (state = questState, action) => {
  if (action.gameId && action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'LOAD_ADAPTIVITY_MAP':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      return { ...state, ...action.payload.newQuestState };
    case 'COMPLETE_EREADER_STEP': {
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      const { questIndex, skillId, gameId } = action.payload;
      const questKey = `quest${questIndex}`;
      const currentQuest = state.quests[questKey];

      steps = currentQuest.steps.map((step) => {
        if (step.skillId === skillId && step.game === gameId) {
          return { ...step, levelsMastered: [...step.levels] };
        }
        return step;
      });

      return {
        ...state,
        quests: {
          ...state.quests,
          [questKey]: {
            ...currentQuest,
            steps,
            startDate: currentQuest.startDate || getTimestamp(),
            updated: getTimestamp(),
          },
        },
      };
    }
    case 'SET_QUEST_STEP_LEVEL_MASTERED':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      product = action.payload.product;
      steps = [...state.quests[`quest${action.payload.questIndex}`].steps];
      selectedStep = steps.filter((step, stepIndex) => {
        if (step.skillId === undefined) {
          return action.payload.skillId === stepIndex;
        }
        return action.payload.skillId === step.skillId;
      });
      levelsMastered = [...(selectedStep[0] || {}).levelsMastered || []];
      if (!levelsMastered.includes(action.payload.levelMastered)) {
        levelsMastered.push(action.payload.levelMastered);
        index = steps.findIndex((step, stepIndex) => {
          if (step.skillId === undefined) {
            return stepIndex === action.payload.skillId;
          }
          return isMatchingGame(step.game, action.payload.game) && step.skillId === action.payload.skillId;
        });
        steps[index] = {
          ...steps[index],
          levelsMastered,
          product,
        };
        newQuestStepsCache = [...state[`${product}QuestStepsCache`]];
        cacheIndex = newQuestStepsCache.findIndex((step, stepIndex) => {
          if (!step) return false;
          if (step.skillId === undefined) {
            return stepIndex === action.payload.skillId;
          }
          return isMatchingGame(step.game, action.payload.game) && step.skillId === action.payload.skillId;
        });
        if (cacheIndex !== -1) {
          newQuestStepsCache[cacheIndex] = { ...steps[index] };
        }
        /* add new level mastered to an array */
        return {
          ...state,
          stepFailures: {
            ...state.stepFailures,
            [`${action.payload.game}_${action.payload.levelMastered}`]: 0,
            currentLevel: action.payload.levelMastered,
          },
          quests: {
            ...state.quests,
            [`quest${action.payload.questIndex}`]: {
              ...state.quests[`quest${action.payload.questIndex}`],
              steps,
              startDate: state.quests[`quest${action.payload.questIndex}`].startDate || getTimestamp(),
              updated: getTimestamp(),
            },
          },
          [`${product}QuestStepsCache`]: newQuestStepsCache,
        };
      }
      /* level is already mastered */
      return {
        ...state,
        stepFailures: {
          ...state.stepFailures,
          [`${action.payload.game}_${action.payload.levelMastered}`]: 0,
          currentLevel: action.payload.levelMastered,
        },
      };
    case 'SET_SIDE_QUEST_STEP_LEVEL_MASTERED':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      steps = [...state.sideQuest.games];
      selectedStep = steps.filter(step => isMatchingGame(step.game, action.payload.game));
      levelsMastered = [...(selectedStep[0] || {}).levelsMastered || []];
      if (!levelsMastered.includes(action.payload.levelMastered)) {
        levelsMastered.push(action.payload.levelMastered);
        index = steps.findIndex(step => isMatchingGame(step.game, action.payload.game));
        steps[index] = {
          ...steps[index],
          levelsMastered,
        };
        /* add new level mastered to an array */
        return {
          ...state,
          stepFailures: {
            ...state.stepFailures,
            [`${action.payload.game}_${action.payload.levelMastered}`]: 0,
            currentLevel: action.payload.levelMastered,
          },
          sideQuest: {
            ...state.sideQuest,
            games: [
              ...steps,
            ],
          },
        };
      }
      /* level is already mastered */
      return {
        ...state,
        stepFailures: {
          ...state.stepFailures,
          [`${action.payload.game}_${action.payload.levelMastered}`]: 0,
          currentLevel: action.payload.levelMastered,
        },
      };
    case 'NOTIFY_STEP_FAILURE_QUEST': {
      const currentFailure = state.stepFailures[`${action.payload.game}_${action.payload.level}`]
        ? state.stepFailures[`${action.payload.game}_${action.payload.level}`] : 0;
      return {
        ...state,
        stepFailures: {
          ...state.stepFailures,
          [`${action.payload.game}_${action.payload.level}`]: currentFailure + 1,
          currentLevel: action.payload.level,
        },
      };
    }
    case 'COMPLETE_FAILED_GAME':
      steps = Object.assign([], state.quests[`quest${action.payload.questIndex}`].steps);
      index = steps.findIndex((step, stepIndex) => {
        if (step.skillId === undefined) {
          return stepIndex === action.payload.skillId;
        }
        return isMatchingGame(step.game, action.payload.game) && step.skillId === action.payload.skillId;
      });
      steps[index].levelsMastered = steps[index].levels;
      return {
        ...state,
        quests: {
          ...state.quests,
          [`quest${action.payload.questIndex}`]: {
            ...state.quests[`quest${action.payload.questIndex}`],
            steps,
            startDate: state.quests[`quest${action.payload.questIndex}`].startDate || getTimestamp(),
            updated: getTimestamp(),
          },
        },
      };
    case 'CLEAR_LEVEL_STUCKNESS': {
      const { levels = [], game } = action.payload;
      const skillFailuresObject = {};
      for (let i = levels.length; i--;) {
        skillFailuresObject[`${game}_${levels[i]}`] = 0;
      }
      return {
        ...state,
        stepFailures: {
          ...state.stepFailures,
          ...skillFailuresObject,
        },
      };
    }
    case 'CLEAR_QUEST_FAILURES_BUCKET':
      return {
        ...state,
        stepFailures: {
          currentLevel: -1,
        },
      };
    case 'SET_QUEST_STEP_INTRO_COMPLETE':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      steps = Object.assign([], state.quests[`quest${action.payload.questIndex}`].steps);
      return {
        ...state,
        quests: {
          ...state.quests,
          [`quest${action.payload.questIndex}`]: {
            ...state.quests[`quest${action.payload.questIndex}`],
            questIntroPlayed: action.payload.index,
            // If startDate is not already defined (ie, if we used Admin panel to jump to this quest)
            // then save the Quest startDate now
            startDate: state.quests[`quest${action.payload.questIndex}`].startDate || getTimestamp(),
            updated: getTimestamp(),
          },
        },
      };

    case 'SET_LAST_STEP_TO_ANIMATE':
      return {
        ...state,
        mapAreas: {
          ...state.mapAreas,
          updated: getTimestamp(),
          [action.payload.location]: {
            ...state.mapAreas[action.payload.location],
            lastStepToAnimate: action.payload.game,
          },
        },
      };

    case 'CLEAR_LAST_STEP_TO_ANIMATE':
      return {
        ...state,
        mapAreas: {
          ...state.mapAreas,
          updated: getTimestamp(),
          [action.payload.location]: {
            ...state.mapAreas[action.payload.location],
            lastStepToAnimate: '',
          },
        },
      };

    case 'SET_LOCATION_PROGRESS':
      return {
        ...state,
        mapAreas: {
          ...state.mapAreas,
          updated: getTimestamp(),
          [action.payload.location]: {
            ...state.mapAreas[action.payload.location],
            locationProgress: action.payload.progress,
          },
        },
      };
    case 'SET_QUEST_LOCATION_ACTIVE': {
      // When all quests are completed, the "next" quest doesn't exist, so we use questId = 0.
      // In this case, there is no need to set a startDate, so we just leave quests state as it is
      const quests = action.payload.questId === 0 ?
        state.quests :
        {
          ...state.quests,
          [`quest${action.payload.questId}`]: {
            ...state.quests[`quest${action.payload.questId}`],
            startDate: state.quests[`quest${action.payload.questId}`].startDate || getTimestamp(),
            updated: getTimestamp(),
          },
        };
      return {
        ...state,
        currentActiveLocation: action.payload.location,
        currentActiveQuestId: action.payload.questId,
        mapAreas: {
          ...state.mapAreas,
          updated: getTimestamp(),
          [action.payload.location]: {
            defaultQuestForLocation: parseInt(action.payload.questId, 10),
            locationProgress: 0,
            lastStepToAnimate: '',
            locationOpened: true,
          },
        },
        quests,
        showChallengeQuestPopup: {
          ...state.showChallengeQuestPopup,
          [action.payload.product]: action.payload.questId === 0,
        },
      };
    }
    case 'SET_END_OF_QUEST_SEEN':
      return {
        ...state,
        didEndOfQuestsPlay: true,
      };
    case 'SET_SHOW_CUSTOM_INTERACTION':
      return {
        ...state,
        isPostQ1InteractionEnabled: true,
      };
    case 'SET_HIDE_CUSTOM_INTERACTION':
      return {
        ...state,
        isPostQ1InteractionEnabled: false,
      };
    case 'SET_NOTES_TAB_VISIBILITY':
      return {
        ...state,
        isNotesTabVisible: true,
      };
    case 'SET_QUEST_LOCATION_OPENED':
      return action.payload.location === ''
        ? {
          ...state,
          mapAreas: {
            ...state.mapAreas,
            updated: getTimestamp(),
            [action.payload.previousLocation]: {
              ...state.mapAreas[action.payload.previousLocation],
              locationOpened: false,
            },
          },
        }
        : {
          ...state,
          mapAreas: {
            ...state.mapAreas,
            updated: getTimestamp(),
            [action.payload.location]: {
              ...state.mapAreas[action.payload.location],
              locationOpened: true,
            },
            [action.payload.previousLocation]: {
              ...state.mapAreas[action.payload.previousLocation],
              locationOpened: false,
            },
          },
        };

    case 'ADD_BITES_EARNED_IN_QUEST':
      return {
        ...state,
        bitesEarnedInQuest: state.bitesEarnedInQuest + action.payload.bites,
      };

    case 'REDUCE_BITES_EARNED_IN_QUEST':
      return {
        ...state,
        bitesEarnedInQuest: state.bitesEarnedInQuest - action.payload.bites,
      };
    case 'HIDE_SIDE_QUEST_GAME_POPUP':
      return {
        ...state,
        sideQuest: {
          ...state.sideQuest,
          showSideQuestGamesPopup: false,
        },
      };
    case 'SET_SIDE_QUEST_GAME':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      return {
        ...state,
        sideQuest: {
          ...state.sideQuest,
          selectedGame: action.payload.gameId,
        },
      };
    case 'SHOW_SIDE_QUEST_GAME_POPUP':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      return {
        ...state,
        sideQuest: {
          ...state.sideQuest,
          showSideQuestGamesPopup: true,
        },
      };
    case 'SHOW_SIDE_QUEST_AVAILABILITY_POPUP':
      if (state.season === SEASON.GRADE_2_3 || state.season === SEASON.GRADE_4_5) {
        return state;
      }
      return {
        ...state,
        sideQuest: {
          ...state.sideQuest,
          showSideQuestAvailability: true,
        },
      };
    case 'HIDE_SIDE_QUEST_AVAILABILITY_POPUP':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      return {
        ...state,
        sideQuest: {
          ...state.sideQuest,
          showSideQuestAvailability: false,
          showChallengeIconOnMap: true,
        },
      };
    case 'DISABLE_SIDE_QUEST':
      if (state.season === SEASON.GRADE_4_5) {
        return state;
      }
      return {
        ...state,
        sideQuest: {
          ...questState.sideQuest,
        },
      };
    case 'CHANGE_LANGUAGE':
      return {
        ...state,
        language: action.payload.language,
      };
    case 'UPDATE_CAPTIONS_AVAILABILITY':
      return { ...state, areCaptionsBlocked: action.payload };
    case 'CHANGE_CAPTIONS':
      return { ...state, captions: action.payload };
    case 'ENABLE_PRACTICE_LOCALLY':
      return {
        ...state,
        practiceEnabledLocally: action.payload,
        showPracticeTab: action.payload,
      };
    case 'MARK_ALL_QUESTS_AND_CHALLENGES_COMPLETE': {
      return {
        ...state,
        areAllQuestsAndChallengesComplete: {
          ...state.areAllQuestsAndChallengesComplete,
          [action.payload.product]: true,
        },
      };
    }
    case 'NOTIFY_USER_HAS_QUESTS_COMPLETE_POPUP_SHOWN':
      return {
        ...state,
        userHadAllQuestsCompletePopupShown: {
          ...state.userHadAllQuestsCompletePopupShown,
          [action.payload.product]: true,
        },
      };
    case 'UPDATE_CHALLENGE_QUEST':
      return {
        ...state,
        quests: {
          ...state.quests,
          quest100: {
            steps: [
              ...action.payload.games,
            ],
          },
        },
        bitesEarnedInQuest: 0, // new set of challenge games means reset bitesEarnedInQuest
      };
    case 'HIDE_CHALLENGE_QUEST_POPUP':
      return {
        ...state,
        showChallengeQuestPopup: {
          ...state.showChallengeQuestPopup,
          [action.payload.product]: false,
        },
      };
    case 'UNLOCK_GLYPH_POWER':
      return {
        ...state,
        unlockedGlyphPowers: [
          ...state.unlockedGlyphPowers,
          action.payload.item,
        ],
      };

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL:
      return validateReducerData(state, action);

    case persistStateTypes.SET_AUTH: {
      if (state.isQuestInDemoMode) {
        return state;
      }
      let season = SEASON.GRADE_K_1; // default to season 1 first
      if (action.payload.season !== undefined && action.payload.season !== 'undefined') {
        season = action.payload.season;
      }
      return {
        ...state,
        season,
      };
    }

    case 'SET_VOCAB_AS_GAME_STEP': {
      const currentQuest = `quest${state.currentActiveQuestId}`;
      const newSteps = [...state.quests[currentQuest].steps];
      let isVocabCompleted = false;
      const { GameData: { questProgress } = {} } = state.gamesData[gameIds.VOCAB];
      if (questProgress && questProgress[state.currentActiveQuestId]) {
        if (questProgress[state.currentActiveQuestId] === 'finished') {
          isVocabCompleted = true;
        }
      }
      newSteps[newSteps.length - 1] = {
        type: STEP_TYPE.VOCAB,
        game: gameIds.VOCAB,
        levels: [0],
        levelsMastered: isVocabCompleted ? [0] : [],
        product: PRODUCT_READING,
        skillId: -(newSteps.length),
      };

      return {
        ...state,
        quests: {
          ...state.quests,
          [currentQuest]: {
            ...state.quests[currentQuest],
            steps: [
              ...newSteps,
            ],
            startDate: state.quests[currentQuest].startDate || getTimestamp(),
            updated: getTimestamp(),
          },
        },
      };
    }
    case 'RESET_VOCAB_TO_GAME_STEP': {
      const currentQuest = `quest${state.currentActiveQuestId}`;
      const newSteps = [...state.quests[currentQuest].steps];
      const defaultSteps = [...questState.quests[currentQuest].steps];
      newSteps[newSteps.length - 1] = { ...defaultSteps[newSteps.length - 1] };
      return {
        ...state,
        quests: {
          ...state.quests,
          [currentQuest]: {
            ...state.quests[currentQuest],
            steps: [
              ...newSteps,
            ],
            startDate: state.quests[currentQuest].startDate || getTimestamp(),
            updated: getTimestamp(),
          },
        },
      };
    }
    case 'SET_LAST_QUEST_PLAYED_BEFORE_END_OF_QUESTS':
      return {
        ...state,
        lastQuestFinishedBeforeEndOfQuests: state.currentActiveQuestId,
      };
    case 'HIDE_NEW_QUEST_AVAILABLE_POPUP':
      return {
        ...state,
        showNewQuestsAvailablePopup: false,
      };
    case 'UNLOCK_NEW_QUEST_AVAILABLE': {
      const newQuestId = state.newQuestReleased;
      const questLocation = state.questsOrder[`quest${newQuestId}`].location;
      return {
        ...state,
        currentActiveLocation: questLocation,
        currentActiveQuestId: newQuestId,
        userHadAllQuestsCompletePopupShown: false,
        didEndOfQuestsPlay: false,
        showPracticeTab: false,
        mapAreas: {
          ...state.mapAreas,
          updated: getTimestamp(),
          [questLocation]: {
            ...state.mapAreas[questLocation],
            locationOpened: true,
            defaultQuestForLocation: newQuestId,
            locationProgress: 0,
            lastStepToAnimate: '',
          },
        },
      };
    }
    case 'HIDE_RE_PLACEMENT_POPUP':
      return {
        ...state,
        isRePlacementModalShown: false,
      };
    case 'SET_QUEST_SESSION_ID': {
      if (state.season === SEASON.GRADE_4_5 || !action.payload.newQuestSessionId) {
        return state;
      }
      if (state.currentActiveQuestId) {
        const currentQuest = `quest${state.currentActiveQuestId}`;
        return {
          ...state,
          questSessionId: action.payload.newQuestSessionId,
          quests: {
            ...state.quests,
            [currentQuest]: {
              ...state.quests[currentQuest],
              questSessionId: action.payload.newQuestSessionId,
            },
          },
        };
      }
      return state;
    }
    case 'CLEAR_QUEST_SESSION_ID':
      return {
        ...state,
        questSessionId: '',
      };
    case 'CLEAR_QUEST_STEPS_FROM_PRODUCT_CACHE':
      return {
        ...state,
        readingQuestStepsCache: [],
        lecturaQuestStepsCache: [],
      };
    case 'UPDATE_QUEST_STEPS_FROM_PRODUCT_CACHE': {
      const currentQuest = `quest${state.currentActiveQuestId}`;
      return {
        ...state,
        quests: {
          ...state.quests,
          [currentQuest]: {
            ...state.quests[currentQuest],
            steps: action.payload.newQuestSteps,
          },
        },
      };
    }
    case 'SET_CACHED_PRODUCT_QUEST_STEPS':
      product = action.payload.product;
      return {
        ...state,
        [`${product}QuestStepsCache`]: [...action.payload.cachedProductQuestSteps],
      };
    case 'UPDATE_EREADER_STEP': {
      return {
        ...state,
        gamesData: {
          ...state.gamesData,
          [action.payload.bookId]: {
            ...state.gamesData[action.payload.bookId],
            ...action.payload.data,
          },
        },
      };
    }
    case 'SET_INITIAL_QUEST_STATE_FOR_LECTURA': {
      return {
        ...state,
        quests: { ...state.quests, ...MapQuestsLectura.quests },
      };
    }
    case 'SET_GAME_LEVEL_CONCEPT_MAP':
      return {
        ...state,
        gameLevelConceptMap: action.payload,
      };

    case 'SET_OBSERVATION_API_FAILURE_DATA': {
      const { gameLevel, isResolved, observationData } = action.payload;
      const { [gameLevel]: _, ...rest } = state.observationApiFailures;

      // isResolved: the /observation POST resend succeeded, so remove the failure data
      if (isResolved) {
        return {
          ...state,
          observationApiFailures: rest,
        };
      }

      // add /observation POST failure data to attempt retry later
      return {
        ...state,
        observationApiFailures: {
          ...state.observationApiFailures,
          [gameLevel]: observationData,
        },
      };
    }

    case 'SET_WRITE_RESULT_FAILURE_DATA': {
      const { roundSessionId, isResolved, writeResultData } = action.payload;
      const { [roundSessionId]: _, ...rest } = state.writeResultFailures;

      // isResolved: the /writeResult PUT resend succeeded, or was confirmed unretryable, so remove the failure data
      if (isResolved) {
        return {
          ...state,
          writeResultFailures: rest,
        };
      }

      // add /writeResult PUT failure data to attempt retry later
      return {
        ...state,
        writeResultFailures: {
          ...state.writeResultFailures,
          [roundSessionId]: writeResultData,
        },
      };
    }

    default:
      return state;
  }
};

export default questWorkflowReducer;
